import * as THREE from "three";
import { scene } from "./scene";
import { GLTFLoader } from "three/addons/loaders/GLTFLoader.js";
import { ControlFunction } from "./controlFunction";
const loader = new GLTFLoader();
import { progressbar, modelsLoaded } from "./progressbar";

const loadDrone = () => {
    const promiseDrone = new Promise((resolve, reject) => {
        loader.load(
            "office/model/drone/drone.gltf",
            function (gltf) {
                scene.add(gltf.scene);
                const model = gltf.scene;

                // Posizione iniziale da regolare
                model.position.set(-1, 3.0, 4); 
                model.scale.set(0.2, 0.2, 0.2);
                model.rotation.set(0, 0, 0);

                model.traverse(function (object) {
                    if (object.isMesh) {
                        object.castShadow = true;
                        object.receiveShadow = true;
                    }
                });

                // Controllo riabilitato per posizionamento
                //ControlFunction(model);

                // --- ANIMAZIONE DRONE ---
                const clock = new THREE.Clock();
                const waypoints = [
                    new THREE.Vector3(3.5, 3.0, 4),
                    new THREE.Vector3(3.5, 3.0, 9.5),
                    new THREE.Vector3(-3.5, 3.0, 9.5),
                    new THREE.Vector3(-3.5, 3.0, 4)
                ];
                let currentWaypoint = 0;
                const speed = 1.2;
                const lerpFactor = 0.02;

                function animateDrone() {
                    if (model.userData.isDragging) {
                        requestAnimationFrame(animateDrone);
                        return;
                    }
                    const time = clock.getElapsedTime();
                    
                    // 1. Calcolo posizione base (movimento a rettangolo)
                    const target = waypoints[currentWaypoint];
                    const dist = model.position.distanceTo(target);
                    
                    if (dist < 0.5) {
                        currentWaypoint = (currentWaypoint + 1) % waypoints.length;
                    }
                    
                    // Movimento fluido verso il target
                    const direction = new THREE.Vector3().subVectors(target, model.position).normalize();
                    model.position.addScaledVector(direction, speed * 0.016); // Circa 60fps delta

                    // 2. WOBBLE (L'effetto barcollante)
                    // Oscillazioni sinusoidali su vari assi con frequenze diverse
                    const wobbleX = Math.sin(time * 2.5) * 0.05;
                    const wobbleY = Math.cos(time * 3.1) * 0.08;
                    const wobbleZ = Math.sin(time * 1.8) * 0.05;
                    
                    model.position.x += wobbleX * 0.1;
                    model.position.y += wobbleY * 0.1;
                    model.position.z += wobbleZ * 0.1;

                    // 3. ROTAZIONE (Inclinazione dinamica)
                    // Il drone "guarda" verso dove va
                    const lookTarget = target.clone();
                    model.lookAt(lookTarget);
                    
                    // Aggiungiamo un leggero roll/pitch oscillante per realismo
                    model.rotation.x += Math.sin(time * 2.0) * 0.05; 
                    model.rotation.z += Math.cos(time * 2.5) * 0.05;

                    requestAnimationFrame(animateDrone);
                }

                animateDrone();

                resolve(model);
                progressbar();
            },
            undefined,
            function (error) {
                console.error(error);
                reject(error);
            }
        );
    });
    return promiseDrone;
};

export { loadDrone };
